import { ColorSystemOptions } from '@mui/joy/styles/extendTheme';
import { DefaultColorScheme } from '@mui/joy/styles/types';

declare module '@mui/joy/styles' {
  interface Palette {
    purple: {
      50: string;
      100: string;
      200: string;
      300: string;
      400: string;
      500: string;
      600: string;
      700: string;
      800: string;
      900: string;
    };
  }
}

export const ColorSchemes: Partial<Record<DefaultColorScheme, ColorSystemOptions>> = {
  light: {
    palette: {
      background: {
        body: 'var(--joy-palette-neutral-100)',
      },
      primary: {
        50: '#f1f8ff',
        100: '#e2f1ff',
        200: '#b7dbff',
        300: '#7ebeff',
        400: '#599fe5',
        500: '#0073e6',
        600: '#0061c2',
        700: '#004d99',
        800: '#002c58',
        900: '#101b25',
        solidDisabledBg: 'var(--joy-palette-neutral-200)',
      },
      neutral: {
        50: '#f8fbff',
        100: '#f3f6fa',
        200: '#e0e3e9',
        300: '#ced2db',
        400: '#8d95a3',
        500: '#7a8190',
        600: '#545963',
        700: '#2c2f36',
        800: '#1d1e23',
        900: '#0c0d0e',
      },
      danger: {
        50: '#fff0f1',
        100: '#ffe1e4',
        200: '#ffb3bb',
        300: '#f98c97',
        400: '#f36170',
        500: '#d70015',
        600: '#b50012',
        700: '#8f000e',
        800: '#520008',
        900: '#220f11',
      },
      warning: {
        50: '#ffe7c6',
        100: '#ffd292',
        200: '#ffb348',
        300: '#f5a230',
        400: '#d78e26',
        500: '#ae6500',
        600: '#965802',
        700: '#764502',
        800: '#402600',
        900: '#1e1100',
      },
      success: {
        50: '#eefbf2',
        100: '#d6f5df',
        200: '#b0eac4',
        300: '#70d499',
        400: '#48bf7d',
        500: '#25a461',
        600: '#17844d',
        700: '#126a40',
        800: '#115434',
        900: '#0f452d',
      },
      text: {
        secondary: 'var(--joy-palette-neutral-800)',
        primary: 'var(--joy-palette-neutral-800)',
      },
      purple: {
        50: '#f9f7fd',
        100: '#f1ecfb',
        200: '#e5dbf9',
        300: '#d1bff3',
        400: '#b596ea',
        500: '#9b71df',
        600: '#814fce',
        700: '#6c3cb4',
        800: '#5d3693',
        900: '#4c2c77',
      },
    },
  },
  dark: {
    palette: {},
  },
};
